<template>
    <div>
        <music-component v-for="id in localMusics" :key="id" :musicId="id" :category="category"></music-component>
        <music-add-component :category="category"></music-add-component>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import {MUSIC_LIST_GETTER, MUSIC_ACTION_GET_MUSICS, MUSIC_NAMESPACE} from '../../../store/modules/music-types'
    import MusicComponent from './MusicComponent'
    import MusicAddComponent from './MusicAddComponent'

    export default {
        name: 'Musics',
        components: {
            'music-component': MusicComponent,
            'music-add-component': MusicAddComponent
        },
        props: ['category'],
        computed: {
            ...mapGetters(MUSIC_NAMESPACE, {
                musics: MUSIC_LIST_GETTER
            }),
            localMusics: {
                get () { return this.musics(this.category) },
                set (value) {}
            }
        },
        methods: {
            ...mapActions(MUSIC_NAMESPACE, {
                loadMusics: MUSIC_ACTION_GET_MUSICS
            })
        },
        created () {
            this.loadMusics()
        }
    }
</script>

<style lang="scss" scoped>
    .add-pet-link {
        padding-top: 40px;
        text-align: right;
        text-decoration: underline;
    }
</style>



// WEBPACK FOOTER //
// src/components/funeral/music/MusicsComponent.vue